import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { gl } from '@antv/l7-core';
import { dataTypeMap, usageMap } from './constants';

var ReglBuffer = function () {
  function ReglBuffer(reGl, options) {
    _classCallCheck(this, ReglBuffer);

    _defineProperty(this, "buffer", void 0);

    var data = options.data,
        usage = options.usage,
        type = options.type;
    this.buffer = reGl.buffer({
      data: data,
      usage: usageMap[usage || gl.STATIC_DRAW],
      type: dataTypeMap[type || gl.UNSIGNED_BYTE]
    });
  }

  _createClass(ReglBuffer, [{
    key: "get",
    value: function get() {
      return this.buffer;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.buffer.destroy();
    }
  }, {
    key: "subData",
    value: function subData(_ref) {
      var data = _ref.data,
          offset = _ref.offset;
      this.buffer.subdata(data, offset);
    }
  }]);

  return ReglBuffer;
}();

export { ReglBuffer as default };
//# sourceMappingURL=ReglBuffer.js.map